/* import __COLOCATED_TEMPLATE__ from './input-textarea.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

/**
 * This component is a wrapper around a market-field and market-textarea component.
 *
 * ```
 * <Prism::InputTextarea
 *   @value={{this.nameOfValueProperty}}
 *   @inputId="my-id"
 *   @inputClass="some-class some-other-class"
 *   @label="Name"
 *   @placeholder="Put you name here"
 *   @onChange={{action (mut nameOfValueProperty))}}
 * />
 * ```
 *
 */
export default Component.extend({
  tagName: '',
  /**
   * @param {String} inputId - ID to apply to the underlying input field.
   */
  inputId: null,
  /**
   * @param {String} inputClass - Class to apply to the underlying input field
   */
  inputClass: null,
  /**
   * @param {String} inputType - "type" to apply to the underlying input field
   */
  inputType: 'text',
  /**
   * @param {Number} maxlength - maxlength of the underlying input
   */
  maxlength: null,
  /**
   * @param {String} class - Class to apply to the underlying market-field
   */
  class: null,
  /**
   * @param {String} label - Label for the input
   */
  label: null,
  /**
   * @param {String} value - The value passed. This is only relevant to set the initial value of thea field.
   */
  value: null,
  /**
   * @param {String} placeholder - Placeholder of the underlying input field
   */
  placeholder: null,
  /**
   * @param {String} name - name for the input
   */
  name: null,
  /**
   * @param {Boolean} readonly - is the input readonly
   */
  readonly: false,
  /**
   * @param {Boolean} disabled - is the input disabled
   */
  disabled: false,
  /**
   * @param {Boolean} focused - is the input focused
   */
  focused: false,
  /**
   * Optional attribute to determine whether the field should have autocomplete
   * enabled. Note that autocomplete does not play nicely with masking -- some
   * browsers attempt to auto fill the field with the •••• characters.
   *
   * @argument autocomplete
   * @type {String}
   */
  autocomplete: 'off',
  /**
   * @param {Object} validation
   * @param {Boolean} validation.isInvalid - whether or not the field is invalid
   * @param {Boolean} validation.message - validation message to display below the field
   */
  validation: null,
  /**
   * @param {Boolean} showValidation - whether or not the validation is ready to be shown
   */
  showValidation: false,
  /**
   * @param {Action} [onChange] action triggered when the input value changes
   */
  onChange() {},
  /**
   * @param {Function} [onInputLoad] action triggered when the market-input-text has loaded
   */
  onInputLoad() {},
  showError: computed('showValidation', 'validation.isInvalid', function () {
    if (!this.validation) {
      return false;
    }
    return this.validation.isInvalid && this.showValidation;
  }),
  actions: {
    _onChange(event) {
      const value = event.detail.value;
      if (this.onChange) {
        this.onChange(value, event);
      }
    }
  }
});